import React, { useState } from "react";
import ForumCard from "./ForumCard";
import ForumAnswer from "./ForumAnswer";
import "../../styling/Forum.css";

export default function ForumSearch(){

    const DummyList = [
        {
            id: 1,
            context: "test"
        },
        {
            id: 2,
            context: "test 2"
        }
    ]

    const [value, setValue] = useState("");

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!value.trim()) return;
        onSubmit?.(value);
        setValue("");
    };

    const onSubmit = () => {
        console.log("Forum On Submit");
    }

    return (
        <div className="forum-container container-fluid py-3 rounded">
            <form
                onSubmit={handleSubmit}
                className="forum-search-bar align-items-center shadow-sm"
            >
                <input
                    type="text"
                    className="form-control border-0"
                    placeholder="Search"
                    value={value}
                    onChange={(e) => setValue(e.target.value)}
                />
                <button
                    type="submit"
                    className="btn btn-primary rounded-circle ms-2"
                >
                    ➤
                </button>
            </form>

            {DummyList.map((item) => {
                return (
                    <ForumCard information={item} key={item.id} />
                );
            })}
            <ForumAnswer />
        </div>
    );
}